import { FC } from "react";
import { ActivityByProps } from "./types";
import { Row } from "../../../containers";
import { Text } from "../../../typography";
import { useThemeStore } from "../../../../stores";

const ActivityBy: FC<ActivityByProps> = ({ children }) => {
  const theme = useThemeStore((state) => state.theme);
  return (
    <Row gap={5}>
      <Text size={10} color={theme.icon}>
        ادمین :
      </Text>
      <Text size={10} color={theme.icon}>
        {children.fullname}
      </Text>
    </Row>
  );
};

export default ActivityBy;
